import { defineTokens } from '@chakra-ui/react';

export const fontSizes = defineTokens.fontSizes({
	'2xs': {
		value: 'clamp(0.5rem, 0.8vw, 0.625rem)',
	},
	xs: {
		value: 'clamp(0.75rem, 1vw, 0.75rem)',
	},
	sm: {
		value: 'clamp(0.875rem, 1.2vw, 0.875rem)',
	},
	md: {
		value: 'clamp(0.875rem, 1.5vw, 1rem)',
	},
	lg: {
		value: 'clamp(1rem, 1.7vw, 1.125rem)',
	},
	xl: {
		value: 'clamp(1.125rem, 2vw, 1.25rem)',
	},
	'2xl': {
		value: 'clamp(1.25rem, 2.5vw, 1.5rem)',
	},
	'3xl': {
		value: 'clamp(1.5rem, 3vw, 2rem)',
	},
	'4xl': {
		value: 'clamp(1.75rem, 3.5vw, 2.5rem)',
	},
	'5xl': {
		value: 'clamp(2rem, 4vw, 3rem)',
	},
	'6xl': {
		value: 'clamp(2.5rem, 5vw, 3.75rem)',
	},
	'7xl': {
		value: 'clamp(3rem, 6vw, 4.5rem)',
	},
	'8xl': {
		value: 'clamp(4rem, 8vw, 6rem)',
	},
	'9xl': {
		value: 'clamp(5rem, 10vw, 8rem)',
	},
});
